module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/light-slider/slider1/slider1.component.scss
// module id = ./src/app/features/light-slider/slider1/slider1.component.scss
// module chunks = main